import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { AdminSidebar } from "@/components/sidebars";
import { apiClient, formatApiError, API } from "@/lib/api";
import Pagination from "@/components/Pagination";
import { toast } from "sonner";

const STATUSES = ["pendiente", "asignada", "en_camino", "completada", "cancelada"];
const PAGE_SIZE = 50;

export default function AdminSolicitudes() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const load = () => {
    const params = new URLSearchParams({ page, page_size: PAGE_SIZE });
    if (filter) params.set("status", filter);
    apiClient
      .get(`/admin/solicitudes?${params.toString()}`)
      .then((res) => {
        setList(res.data);
        setTotal(parseInt(res.headers["x-total-count"] || "0", 10));
      })
      .catch(() => {});
  };
  useEffect(load, [filter, page]);
  useEffect(() => { setPage(1); }, [filter]);

  const openExpedientePDF = async (sid) => {
    try {
      const res = await apiClient.get(`/admin/solicitudes/${sid}/expediente.pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      toast.error("No se pudo generar el expediente PDF");
    }
  };

  const copyExpedienteJSON = async (sid) => {
    try {
      const res = await apiClient.get(`/admin/solicitudes/${sid}/expediente.json`);
      await navigator.clipboard.writeText(JSON.stringify(res.data, null, 2));
      toast.success("Expediente JSON copiado al portapapeles");
    } catch (e) {
      toast.error("No se pudo copiar el expediente JSON");
    }
  };

  const updateStatus = async (sid, status) => {
    try {
      await apiClient.patch(`/admin/solicitudes/${sid}`, { status });
      toast.success("Solicitud actualizada");
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    }
  };

  return (
    <AppLayout sidebar={AdminSidebar}>
      <header className="app-header">
        <h1>Solicitudes de Servicio</h1>
        <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
          <select value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="filter-status">
            <option value="">Todas</option>
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </header>
      <div className="panel">
        <table className="data-table">
          <thead><tr><th>Fecha</th><th>Tipo</th><th>Cliente</th><th>Beneficiario</th><th>Ubicación / Tel</th><th>Descripción</th><th>Status</th><th>Expediente</th></tr></thead>
          <tbody>
            {list.map((s) => (
              <tr key={s.id} data-testid={`sol-row-${s.id}`}>
                <td>{new Date(s.created_at).toLocaleString("es-MX")}</td>
                <td><strong>{s.tipo.toUpperCase()}</strong></td>
                <td>{s.user_nombre}<br/><small>{s.user_email}</small></td>
                <td>{s.beneficiario?.nombre}<br/><small>{s.beneficiario?.municipio}, {s.beneficiario?.estado} · CP {s.beneficiario?.codigo_postal}</small></td>
                <td>{s.ubicacion || s.beneficiario?.calle + " " + (s.beneficiario?.numero_ext || "")}<br/><small>{s.telefono_contacto}</small></td>
                <td style={{ maxWidth: 280 }}>{s.descripcion}</td>
                <td>
                  <select value={s.status} onChange={(e) => updateStatus(s.id, e.target.value)} data-testid={`update-${s.id}`}>
                    {STATUSES.map((st) => <option key={st} value={st}>{st}</option>)}
                  </select>
                </td>
                <td>
                  <div style={{ display: "flex", gap: 6, flexDirection: "column" }}>
                    <button onClick={() => openExpedientePDF(s.id)} className="btn-mini" data-testid={`pdf-${s.id}`} title="Ver expediente PDF">
                      <i className="fas fa-file-pdf" /> PDF
                    </button>
                    <button onClick={() => copyExpedienteJSON(s.id)} className="btn-mini" data-testid={`json-${s.id}`} title="Copiar JSON al portapapeles">
                      <i className="fas fa-code" /> JSON
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination page={page} pageSize={PAGE_SIZE} total={total} onChange={setPage} testId="solicitudes" />
      </div>
    </AppLayout>
  );
}
